import React from 'react';
import ReactDOM from 'react-dom';
import moment from "moment";

// 3rd party
import Loader from 'calcite-react/Loader';
import Tooltip from "calcite-react/Tooltip";
import ClockIcon from 'calcite-ui-icons-react/ClockIcon';
import PinIcon from 'calcite-ui-icons-react/PinIcon';
import XIcon from 'calcite-ui-icons-react/XIcon';
import PencilIcon from "calcite-ui-icons-react/PencilIcon";
import WarningIcon from "calcite-ui-icons-react/ExclamationMarkTriangleIcon";
import BookingCancel from '../More/Actions/BookWorkspace/BookingCancel';

// aiim.base
import ItemReference from '../../../aiim/base/ItemReference';

// aiim.datasets
import FieldNames from '../../../aiim/datasets/FieldNames';

// aiim.util
import { getAttributeValue } from '../../../aiim/util/aiimUtil';

// common.components.Modal
import { ModalController } from '../../../common/components/Modal';

// components.main.More.Actions.BookWorkspace.WorkspaceReservation
import { getBookings, cancelBooking } from '../More/Actions/BookWorkspace/WorkspaceReservation/OfficeHotelingInterface';
import { formatDate, queryUnitByUnitId, getMeetingBookingSystemType } from '../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil';

// components.util
import * as component from '../../util/component';
import * as workspaceReservationUtil from '../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil';
import * as dateUtil from '../Events/dateUtil';
import Office365 from '../More/Actions/BookWorkspace/WorkspaceReservation/Office365';

// context
import Context from '../../../context/Context';
import Topic from '../../../context/Topic';

// util
import { isNetworkError } from '../../../util/networkUtil';
import { stringFormatter } from '../../../util/formatUtil';
import * as validateUtil from "../More/Actions/BookWorkspace/validateUtil";
import Schedule from "./Schedule";
import Book from './Book';

const CSS = {
  bookingCardList: "i-booking-card-list",
  bookingCard: "i-booking-card",
  bookingInfoLine: "i-booking-info-line",
  locationDescription: "i-booking-location-description",
  flexRow: "i-flex-row",
  addToCalendar: "i-booking-add-calendar",
  cancel: "i-booking-cancel",
  edit: "i-booking-edit",
  popoutInner: "i-popout-inner i-meeting-cancel-confirmed",
  popoutOuter: "i-popout-outer",
  panelHeader: "i-infopanel-header i-panel-header",
  panelHeaderTools: "i-panel-header-tools",
  cancelConfirmed: "i-meeting-cancel-confirmed-body",
  meetingTitle: "i-meeting-cancel-confirmed--title",
  actionGroup: "i-action-group i-my-bookings",
  bookingDescription: "i-booking-description"
};

export default class MyMeetingRoomsOffice365 extends React.Component {

  constructor(props) {
    super(props);

    this.state = component.newState({
      bookings: [],
      isWorking: true
    });
  }

  componentDidMount() {
    this._init();
    Topic.subscribe(Topic.RenderMeetingListOffice365, ()=> {
      this.setState({isWorking: true})
      this._init();
    })
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.bookingDateFilter !== this.props.bookingDateFilter) {
      this.setState({isWorking: true});
      this._init();
    }
  }

  _getBookings = () => {
    return new Promise((resolve, reject) => {
      let currentDateTime = moment(Date.now()).add(1,"milliseconds").toISOString();
      const params = {
        currentDateTime: currentDateTime,
        bookingType: "meetingRooms",
        bookingDateFilter: this.props.bookingDateFilter
      }

      getBookings(this.props.bookingSystem, params)
      .then(scheduleResult => {
        resolve(scheduleResult);
      }).catch(e => {
        console.error(e);
        reject(e);
      });
    })
  }

  _getUserBookings = async () => {
    return new Promise((resolve, reject) => {
      this._getBookings()
      .then(scheduleResult => {
          let bookings = [], items;
          const value = scheduleResult && scheduleResult.value && scheduleResult.value.length > 0;
          if (value) items = scheduleResult.value;
          if (items) {
            items.forEach((item)=> {
              bookings.push(item);
            })
          }
          this.setState({
            bookings: bookings,
            isWorking: false
          })
          resolve();
        }).catch(e => {
            console.error("Unable to query for user reservations", e);
            this.setState({
                bookings: [],
                isWorking: false
            });
        
            if (e && isNetworkError(e.message)) {
            const i18n = Context.getInstance().i18n;
            Topic.publishNetworkError(i18n.meetingRooms.issues.m7);
            } else {
            Topic.publishErrorAccessingData();
            }
            reject(e);
        });
      })
  }

  _init =async()=> {
    return await this._getUserBookings();
  }

  _makeBookingList = (bookings) => {
    return bookings.map((data, i) => {
      const eventId = data && data.id;
      return (
        <MyMeetingRoomsCard
          key={eventId}
          data={data}
          refresh={this._refreshList}
          bookingSystem={this.props.bookingSystem}
        />
      );
    });
  }

  renderBookingCards() {
    const i18n = Context.getInstance().i18n;
    const { bookings } = this.state;
    const bookingList = this._makeBookingList(bookings);

    return bookingList && bookingList.length > 0 ? (
      <ul className={CSS.bookingCardList}>
        {bookingList}
      </ul>
    ) : (
      <div style={{ padding: '0.7rem 1rem' }}>{i18n.meetingRooms.noBookings}</div>
    );
  }
  
  _refreshList = () => {
    this.setState({ isWorking: true });
    this._getUserBookings();
  }

  renderWorking() {
    return (<Loader sizeRatio={1} style={{ marginTop: '3rem' }} />);
  }

  render() {
    const { isWorking } = this.state;
    return isWorking ? this.renderWorking() : this.renderBookingCards();
  }
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

class MyMeetingRoomsCard extends React.Component {
  _componentId;
  _itemRef;
  _isOngoingBooking;

  constructor(props) {
    super(props);
    this._componentId = component.nextId("meeting-room-");
    this._itemRef = React.createRef();
    this._isOngoingBooking = this.isOngoingBooking();
    const isLocationChange = this._isLocationChange();
    this.state = component.newState({
      popoverOpen: false,
      isLocationChange: isLocationChange
    })
  }

  _isLocationChange =()=> {
    const booking = this.props && this.props.data && this.props.data;
    const extensions = booking && booking.extensions && booking.extensions[0];
    const unitId = extensions && extensions.unitId;
    const unc = Context.instance.session.unitNameCache;
    if (unc && unc.defaultNamesPerUnitId && unitId) {
      const origUnitName = unc.defaultNamesPerUnitId[unitId];
      const newUnitName = booking && booking.location && booking.location.displayName;
      if (origUnitName !== newUnitName) return true
      return false;
    }
  }

  isOngoingBooking =() => {
    // const booking = this.props.data;
    // const o365toDateObj = dateUtil.O365toDate(booking.start.dateTime, booking.end.dateTime);
    // const dtStart = o365toDateObj.fromDate;
    // const epochStartTime = new Date(dtStart).getTime();
    // const epochCurrentTime = workspaceReservationUtil.getEpochCurrentTime();
    // if (epochCurrentTime > epochStartTime) return true;
    return false;
  }
  _makeFeatureItem =async()=> {
    const booking = this.props.data;
    const unitName = booking && booking.extensions && booking.extensions[0].unitName;
    const unitId = booking && booking.extensions && booking.extensions[0].unitId;
    let unitFeature = await queryUnitByUnitId(unitId);
    if (unitFeature && unitFeature.features && unitFeature.features.length > 0) unitFeature = unitFeature.features[0];
    const source = Context.instance.aiim.datasets.units.getSource();
    const searchResult = source.makeSearchResult(null, unitFeature);
    const item = new ItemReference();
    item.fromSearchResult(source.key, { feature: unitFeature, name:  searchResult.name});
    return item;
  }

  _statusClicked = async (status) => {
    if (status === "declined") {
      const i18n = Context.instance.i18n;
      const options = {
        title: i18n.meetingRooms.book.declineBookingO365Title,
        message: i18n.meetingRooms.book.declineBookingO365Msg,
        okLabel: i18n.general.ok,
        showOkCancel: true,
        hideCancel : true,
        closeOnOK: true
      };
      ModalController.confirm(options);
      return;
    } else if (status === "mismatchEmail") {
      const booking = this.props && this.props.data;
      const unitName = booking && booking.location && booking.location.displayName;
      const scheduleEmail = booking && booking.extensions && booking.extensions[0] && booking.extensions[0].scheduleEmail;
      let attendeeEmails = [], attendeeEmailsStr;
      for (let i=0;i<booking.attendees.length;i++) {
        const emailAddress = booking.attendees[i].emailAddress.address;
        attendeeEmails.push(emailAddress);
        attendeeEmailsStr = attendeeEmails.join(attendeeEmails)
      }      
      const i18n = Context.instance.i18n;
      let msg = i18n.meetingRooms.emailMismatch.message;
      msg = msg.replace("{scheduleEmail}", scheduleEmail);
      msg = msg.replace("{unitName}", unitName);
      msg = msg.replace("{attendeeEmails}", attendeeEmailsStr)

      ModalController.showError({
        title: i18n.general.information,
        className: "i-portrait-access-hotel-error",
        errors: {
          generic: i18n.meetingRooms.emailMismatch.caption,
          detailed: [msg]
        }
      });
    }
  }

  
  _bookingCardClicked = async (e,considerDeclined) => {
    const isLocationChange = this.state.isLocationChange;
    // const declined = Office365.wasDeclined( this.props.booking);
    if (isLocationChange) {
      const i18n = Context.instance.i18n;
      const options = {
        title: (isLocationChange ? i18n.meetingRooms.locationChange.caption : i18n.meetingRooms.book.declineBookingO365Title),
        message: (isLocationChange ? i18n.meetingRooms.locationChange.message : i18n.meetingRooms.book.declineBookingO365Msg),
        okLabel: i18n.general.ok,
        showOkCancel: true,
        hideCancel : true,
        closeOnOK: true
      };
      ModalController.confirm(options);
      return;
    }
    const booking = this.props && this.props.data;
    const unitId = booking && booking.extensions && booking.extensions[0].unitId;
    let unitFeature = await workspaceReservationUtil.queryUnitByUnitId(unitId);
    if (unitFeature && unitFeature.features && unitFeature.features.length > 0) {
      unitFeature = unitFeature.features[0];
      this.setState({
        unitFeature: unitFeature
      })
    }

    const source = Context.instance.aiim.datasets.units.getSource();
    const item = await this._makeFeatureItem();
    
    Topic.publish(Topic.ShowSearchResult, {
      sourceKey: source.key,
      searchResult: item.searchResult,
      zoom: true,
      highlight: true,
      trackRecent: true,
      componentId: this._componentId
    });
  }

  _cancelClicked = (event) => {
    // Prevent the click event from propagating to the card
    event.stopPropagation();
    this._showCancelPopup(false);
  }

  componentDidMount() {
    component.own(this, [
      Topic.subscribe(Topic.InfoPanelClosed, params => {
        if (this._componentId === params.componentId) {
          this._focus();
        }
      })
    ]);
  }

  _focus() {
    if (this._itemRef && this._itemRef.current && this._itemRef.current.focus) {
      this._itemRef.current.focus();
    }
  }

  _makeItem = () => {
    const { data } = this.props;
    const { unit } = data;
    const units = Context.getInstance().aiim.datasets.units
    const source = units.getSource();

    const item = new ItemReference();
    item.fromSearchResult(source.key, { feature: unit, name: source.getTitle(unit) });
    return item;
  }

  _onKeyDown = (event) => {
    const ENTER = 13;
    const SPACE = 32;
    if (event.keyCode !== ENTER && event.keyCode !== SPACE) {
      return;
    }

    // Prevent propagation from children keyboard events
    const dataId = event.target.getAttribute("data-id");
    if (dataId === "card") {
      event.preventDefault();
      this._bookingCardClicked();
    }
  }

  processScheduleClick = true;

  _scheduleClicked =async()=> {
    if (!this.processScheduleClick) return;
    try {
      this.processScheduleClick = false;
    const i18n = Context.getInstance().i18n;
    const info = await workspaceReservationUtil.getReScheduleInfo(this.props.data, "meetingRooms");
    if (!info) {
      Topic.publish(Topic.RenderMeetingListOffice365, {});
      Topic.publish(Topic.ShowToast,{
        message: i18n.more.bookWorkspace.checkInOut.cancelBooking.bookingNotAvailable
      });
      return;
    }
    const controller = new ModalController();
    const title = i18n.meetingRooms.schedule.captionPattern.replace("{room}",info.item.name);
    const reservationO365 = this.props.data; //obj from O365 graphAPI 
    //example: { id, subject, isAllDay, start: { dateTime:'2022-10-22T21:00:00.0000000', timeZone:'UTC'}, end: {}, location: {displayName,locationType,uniqueId,uniqueIdType}, extenstions:[{}, {}, ...]}

    const modalProps = {
      className: "i-modal-confirm i-modal-schedule",
      title: title,
      cancelLabel: i18n.general.close,
      showOKCancel: true,
      hideOK: true
    };

    const content = (
      <Schedule 
        type = "meetingRooms"
        item={info.item} 
        start={info.start} 
        when={info.when} 
        bookingType="meetingRooms"
        operation={info.operation}
        isOngoingBooking={this._isOngoingBooking}
        originalReservation={{booking: reservationO365, attributes: null}}
        onBookClicked={(selectedWhen) => {
          this._rescheduleBooking(selectedWhen);
          controller.close();
        }}/>
    )
    controller.show(modalProps,content);
    } catch(ex) {
      console.error(ex)
    } finally {
      setTimeout(()=> {
        this.processScheduleClick = true;
      },200)
    }
  }

  _showCancelPopup = (retry) => {
    const i18n = Context.getInstance().i18n;
    const booking = this.props.data;
    const eventId = booking && booking.id;
    const unitName = booking && booking.location && booking.location.displayName;
    let msg = i18n.meetingRooms.cancel.message;
    if (unitName) {
      msg = i18n.meetingRooms.cancel.messagePattern.replace("{unitName}",unitName);
    }
    const message = retry
      ? i18n.meetingRooms.cancel.retry
      : msg;

    const options = {
      title: i18n.meetingRooms.cancel.modalTitle,
      message,
      okLabel: i18n.general.yes,
      cancelLabel: i18n.more.bookWorkspace.no,
      showOKCancel: true,
      closeOnOK: true,
      closeOnCancel: true
    };

    ModalController.confirm(options)
      .then((result) => {
        // User chose to continue canceling the meeting, proceed
        if (result && result.ok) {
            return new Promise((resolve, reject) => {
              let currentDateTime = moment(Date.now()).add(1,"milliseconds").toISOString();
              const params = {
                currentDateTime: currentDateTime,
                bookingType: "meetingRooms"
              }
              getBookings(this.props.bookingSystem, params)
              .then((res)=> {
                const value = res && res.value;
                let isBooking = false;
                for (let i=0;i<value.length;i++) {
                  if (value[i].id === eventId) isBooking = true;
                }
    
                if (!isBooking) {
                  Topic.publish(Topic.ShowToast,{
                    message: i18n.more.bookWorkspace.checkInOut.cancelBooking.bookingNotAvailable
                  });
                  Topic.publish(Topic.RenderMeetingListOffice365, {});
                  return "bookingNotAvailable";;
                } else {
                  const params = {
                    eventId: eventId
                  }
                  return cancelBooking(this.props.bookingSystem, params)
                }
              })
              .then((info) => {

                if (info === "bookingNotAvailable") {
                  resolve();
                  return;
                }
                if (typeof this.props.refresh === "function") {
                    this.props.refresh();
                }
                this._renderCancelConfirmed(booking);       
                resolve();
              }).catch(e => {
                console.error("Couldn't cancel meeting", e);
                // test this
                if (e && isNetworkError(e.message)) {
                    const i18n = Context.getInstance().i18n;
                    const template = i18n.meetingRooms.issues.m9;
                    const message = stringFormatter(template, { unit: unitName });
                    Topic.publishNetworkError(message);
                } else {
                    Topic.publishErrorUpdatingData();
                }

                // Give the user an option to try again
                this._showCancelPopup(true);
            });
          })
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  
  _renderCancelConfirmed(booking) {
    const unitName = booking && booking.location && booking.location.displayName;
    
    const node = document.createElement("div");
    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node);
      }
    };

    document.body.appendChild(node);
    ReactDOM.render(
      <BookingCancel
        bookingSystemType={getMeetingBookingSystemType()}
        unitName={unitName}        
        closePopup={onClose}
        data={this.props.data}
        />, node);
  }

  _togglePopover = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  }

  _rescheduleBooking =async(options)=> {
    const item = await this._makeFeatureItem();
    const feature = item.getFeature();
    const eventId = this.props.data && this.props.data.id;
    const booking = this.props.data;
    const o365toDateObj = dateUtil.O365toDate(booking.start.dateTime, booking.end.dateTime);
    const title = booking && booking.subject;
    const body = booking && booking.body;

    const bookItem = {
      unitId: getAttributeValue(feature.attributes,FieldNames.UNIT_ID),
      name: getAttributeValue(feature.attributes,FieldNames.NAME),
      feature: feature,
      origBooking: o365toDateObj,
      title: title,
      body: body
    };

    let duration = options && options.duration;
    let dtStart = options && options.start.date;
    let dtEnd = options && options.end.date;
    const originalReservation = options && options.originalReservation;

    let criteria = {
      when: {
        duration: duration,
        start: {date: dtStart},
        end: {date: dtEnd}
      },
      eventId: eventId,
      isOngoingBooking: this._isOngoingBooking,
      operation: "updateBookingTime"
    };
    Book.show({ bookItem, criteria, originalReservation });
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const { data } = this.props;
    const booking = data;
    const levels = Context.getInstance().aiim.datasets.levels;
    const isLocationChange = this.state.isLocationChange;
    const declined = Office365.wasDeclined(booking);
    const scheduleEmail = booking && booking.extensions && booking.extensions[0] && booking.extensions[0].scheduleEmail;
    const statusObj = Office365.getEventStatus(booking, scheduleEmail);
    const status = statusObj.status;
    const statusDetails = validateUtil.getStatusIconMsg(statusObj); 
    const statusIcon = statusDetails.icon;
    const statusMsg = statusDetails.msg;
    let borderStyle = statusDetails.borderStyle;

    // Field values to display
    const checkInDate = booking && booking.start;
    const checkOutDate = booking && booking.end;

    const o365toDateObj = dateUtil.O365toDate(checkInDate.dateTime, checkOutDate.dateTime);
    const fromDateTime = o365toDateObj.fromDateTime;
    const toDateTime = o365toDateObj.toDateTime;

    const subject = booking && booking.subject;
    const unitName = booking && booking.location && booking.location.displayName;
    const levelId = booking && booking.extensions && booking.extensions[0].levelId;

    // Level/Facility info
    const levelData = levels.getLevelData(levelId); 
    const levelName = levelData && levelData.levelName;
    const facilityName = levelData && levelData.facilityName;
    const template = i18n.more.bookWorkspace.levelDescription;
    const description = !isLocationChange && stringFormatter(template, {
      level: levelName,
      facility: facilityName
    });
    // let description = `${levelName}, ${facilityName}`;
    // if (this.state.isLocationChange) description = unitName;

    // Format a date string from the start and end times
    const fromDate = o365toDateObj.fromDate;
    const toDate = o365toDateObj.toDate;
    const isAllDay = dateUtil.isAllDay(fromDate.getTime(), toDate.getTime());
    const formattedDate = workspaceReservationUtil.formatDate(fromDateTime, toDateTime, isAllDay);
    const isRTL = Context.getInstance().uiMode.isRtl;
    let marginCss = {marginLeft: "auto"};
    let textAlign = "left";
    if (isRTL) {
      marginCss = {marginRight: "auto"};
      textAlign = "right"
    }

    let marginEditCss = {marginLeft: "8rem"}
    if (isRTL) marginEditCss = {marginRight: "8rem"};

    let statusTitle;
    if (isLocationChange) statusTitle = i18n.meetingRooms.locationChange.message;
    else if (declined) statusTitle = i18n.meetingRooms.book.declineBookingO365Msg;
    else if (status && status === "mismatchEmail") statusTitle = i18n.meetingRooms.emailMismatch.caption;

    if (isLocationChange ||(status && status === "mismatchEmail")) borderStyle = {borderLeft: "1px #dfdfdf solid"}

    return (
      <li>
        <div className={CSS.bookingCard} style={borderStyle}>
          <div
            id={this._componentId}
            className={CSS.bookingDescription}
            ref={this._itemRef}
            role="button"
            tabIndex="0"
            data-id={"card"}
            onClick={this._bookingCardClicked}
            onKeyDown={this._onKeyDown}
          >
            <h3>{subject}</h3>
            <div className={CSS.bookingInfoLine}>
              <ClockIcon />
              <h4>{formattedDate}</h4>
            </div>
            {!isLocationChange && ( 
              <>
                <h4 className={CSS.bookingInfoLine}>
                  <PinIcon />
                  {unitName}
                </h4>
                <h4 className={CSS.locationDescription} style={{paddingLeft: "1.4rem", paddingRight: "1.4rem"}}>{description}</h4>
              </>
            )}
            {isLocationChange && ( 
              <Tooltip style={{textAlign: textAlign}} placement="top" positionFixed={true}
              title={statusTitle}>
                <div
                  role="button"
                  tabIndex="0"
                  onClick={(e) => {
                    e.stopPropagation();
                    this._bookingCardClicked(e,true)
                  }}
                >
                <h4 className="i-booking-info-line i--warn-location-change">
                  <PinIcon />
                  {unitName}
                  <span><WarningIcon className="i--warn" size={16} /></span>
                </h4>
                <h4 className={CSS.locationDescription+" i--warn-location-change"}>{description}</h4>
                </div>
              </Tooltip>
            )}
            {!isLocationChange && !statusTitle && (
                <div className={CSS.bookingInfoLine}>
                  <h4>{statusIcon}</h4>
                  <h4>{statusMsg}</h4>
                </div>
              )
            }

            {!isLocationChange && statusTitle && (
                <Tooltip style={{textAlign: textAlign}} placement="top" positionFixed={true}
                title={statusTitle}>
                  <div
                    role="button"
                    tabIndex="0"
                    onClick={(e) => {
                      e.stopPropagation();
                      this._statusClicked(status)
                    }}
                  >
                    <div className={CSS.bookingInfoLine}>
                      <h4>{statusIcon}</h4>
                      <h4>{statusMsg}</h4>
                    </div>
                  </div>
                </Tooltip>
              )
            }
          </div>
          <div className={CSS.actionGroup}>
            <span></span>
            <span style={{display: "flex"}}>
            <button
              style={marginEditCss}
              className={CSS.edit}
              data-id={"cancel"}
              onClick={this._scheduleClicked}
              disabled={this.state.isLocationChange ||(status && status === "mismatchEmail")}
            >
              <PencilIcon/>
              {i18n.more.bookWorkspace.checkInOut.rescheduleBooking.caption}
            </button>
            <button
              className={CSS.cancel}
              style={marginCss}
              data-id={"cancel"}
              onClick={this._cancelClicked}
            >
              <XIcon />
              {i18n.general.cancel}
            </button>
            </span>
          </div>
        </div>
      </li>
    );
  }
}
